import * as firebase from 'firebase';
/* eslint-disable */ 
export default {
  uploadAll(entityPath, entity, properties) {
    const promises = [];

    properties.forEach((property) => {
      if (!entity[property]) {
        return;
      }

      entity[property]
        .filter((f) => !!f.raw)
        .forEach((f) => {
          promises.push(
            this.upload(entityPath, entity.id, property, f)
          );
        });
    });

    return Promise.all(promises).then(() => entity);
  },

  deleteAll(entityPath, entity, properties) {
    const promises = [];
    
    properties.forEach((property) => {
      if (!entity[property]) {
        return;
      }

      entity[property]
        .forEach((f) => {
          promises.push(
            this.delete(entityPath, entity.id, property, f)
          );
        });
    });

    return Promise.all(promises).then(() => entity);
  },

  fillDownloadURLs(entityPath, entity, properties) {
    const promises = [];

    properties.forEach((property) => {
      if (!entity[property]) {
        return;
      }

      entity[property].forEach((fileItem) => {
        promises.push(
          this.fillDownloadURL(
            entityPath,
            entity.id,
            property,
            fileItem
          )
        );
      });
    });

    return Promise.all(promises).then(() => entity);
  },

  upload(entityPath, id, property, file) {
    return new Promise((resolve, reject) => {
      const uploadTask = firebase
        .storage()
        .ref(`${entityPath}/${id}/${property}/${file.name}`)
        .put(file.raw);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        () => {},
        (error) => {
          reject(error);
        },
        () => {
          resolve();
        }
      );
    });
  },

  uploadB64Img(entityPath, id, property, file) {

    console.log("<-- uploadB64Img");
    console.log(`${entityPath}/${id}/${property}/${firebase.database.ServerValue.TIMESTAMP}`);
    
    return new Promise((resolve, reject) => {

      if (file === undefined || file.data === undefined || file.size === 0) {
        resolve()
      }

      const uploadTask =  firebase
        .storage()
        .ref(`${entityPath}/${id}/${property}/${file.name}`)
        .putString(file.dataB64, 'base64', {contentType:'image/png'})

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        () => {  resolve();},
        (error) => {
          reject(error);
        },
        () => {
          resolve();
        }
      );
    });
  },

  delete(entityPath, id, property, file) {
    return new Promise((resolve, reject) => {
        console.log("<---- delete file");
        console.log(file);
        
        if (file.size === 0 || file.name === "") {
          resolve()
          return
        }

        firebase
        .storage()
        .ref(`${entityPath}/${id}/${property}/${file.name}`)
        .delete().then(() => {
          // File deleted successfully
          resolve();

        }).catch((error) => {
          // Uh-oh, an error occurred!
          reject(error);
        });
    });
  },

  fillDownloadURL(entityPath, id, property, file) {
    
    if (!entityPath) {
      return Promise.reject(
        new Error('Entity path is null!')
      );
    }

    if (!id) {
      return Promise.reject(new Error('Id is null!'));
    }

    if (!property) {
      return Promise.reject(new Error('Property is null!'));
    }

    if (!file ) {
      return Promise.reject(new Error('File is null!'));
    }

    if ( file && file.size === 0){
      return Promise.reject(new Error('File size is 0!'));
    }

    return firebase
      .storage()
      .ref(`${entityPath}/${id}/${property}/${file.name}`)
      .getDownloadURL()
      .then((url) => {
        Object.assign(file, {
          url
        });
      });
  }
};



// WEBPACK FOOTER //
// ./src/shared/file/file-service.js